import { EFO_ROUTE_PATHS } from "..";
import { IconLogIn, IconLogOut } from "../../shared/Icons";
import {
  FooterList,
  HeaderRightMenuInfo,
  MenuInfoList,
  MenuWithSubMenu,
} from "../../types/efoMenuInfoList/menuInfoList.types";

type HeaderType = {
  Home: MenuWithSubMenu;
  News: MenuWithSubMenu;
  Database: MenuWithSubMenu;
};

export const HEADER_INFO: HeaderType = {
  Home: {
    key: "home",
    text: "Home",
    isEnabled: true,
    isOpenSubMenu: false,
    path: EFO_ROUTE_PATHS.introduction,
    subMenu: [
      {
        text: "Landing Page",
        path: EFO_ROUTE_PATHS.introduction,
        isEnabled: true,
      },
    ],
  },
  Database: {
    key: "database",
    text: "Database",
    isEnabled: true,
    isOpenSubMenu: false,
    path: EFO_ROUTE_PATHS.introduction,
    subMenu: [
      {
        text: "Enter the Database",
        isEnabled: true,
      },
      {
        text: "Pricing",
        path: EFO_ROUTE_PATHS.pricing,
        isEnabled: true,
      },
    ],
  },
  News: {
    key: "news",
    text: "News",
    isEnabled: true,
    isOpenSubMenu: false,
    subMenu: [
      {
        text: "News Main",
        path: `${EFO_ROUTE_PATHS.articleMain}`,
        isEnabled: true,
      },
      {
        text: "Newsletter",
        path: `${EFO_ROUTE_PATHS.newsletter}/`,
        isEnabled: true,
      },
      {
        text: "Subscription",
        path: `${EFO_ROUTE_PATHS.newsletter}/subscribe`,
        isEnabled: true,
      },
      {
        text: "Comments",
        path: `${EFO_ROUTE_PATHS.comments}`,
        isEnabled: true,
      },
    ],
  },
};

export const DEFAULT_HEADER_INFO: MenuInfoList = Object.values(HEADER_INFO);

export const MENU_FOR_SIGN_IN_LIST: MenuInfoList = [
  ...DEFAULT_HEADER_INFO,
  {
    key: "account",
    text: "Account",
    isEnabled: true,
    isOpenSubMenu: false,
    subMenu: [
      {
        text: "Sign in",
        path: [EFO_ROUTE_PATHS.signIn],
        isEnabled: true,
      },
      {
        text: "Sign up",
        path: [EFO_ROUTE_PATHS.signUp],
        isEnabled: true,
      },
    ],
  },
];

export const MENU_FOR_SIGN_OUT_LIST: MenuInfoList = [
  ...DEFAULT_HEADER_INFO,
  {
    key: "account",
    text: "Account",
    isEnabled: true,
    isOpenSubMenu: false,
    subMenu: [
      {
        text: "My Account",
        path: [EFO_ROUTE_PATHS.myAccount],
        isEnabled: true,
      },
      {
        text: "Sign out",
        path: [EFO_ROUTE_PATHS.signIn],
        isEnabled: true,
      },
    ],
  },
];

export const FOOTER_DEFAULT_MENU_LIST = [
  {
    title: "Home",
    menuList: HEADER_INFO.Home.subMenu,
  },
  {
    title: "Database",
    menuList: HEADER_INFO.Database.subMenu,
  },
  {
    title: "News",
    menuList: HEADER_INFO.News.subMenu,
  },
];

export const FOOTER_FOR_SIGN_IN_LIST: FooterList[] = [
  ...FOOTER_DEFAULT_MENU_LIST,
  {
    title: "Account",
    menuList: [
      {
        text: "Sign in",
        path: [EFO_ROUTE_PATHS.signIn],
        isEnabled: true,
      },
      {
        text: "Sign up",
        path: [EFO_ROUTE_PATHS.signUp],
        isEnabled: true,
      },
    ],
  },
];

export const FOOTER_FOR_SIGN_OUT_LIST: FooterList[] = [
  ...FOOTER_DEFAULT_MENU_LIST,
  {
    title: "Account",
    menuList: [
      {
        text: "My Account",
        path: [EFO_ROUTE_PATHS.myAccount],
        isEnabled: true,
      },
      {
        text: "Sign out",
        path: [EFO_ROUTE_PATHS.articleMain],
        isEnabled: true,
      },
    ],
  },
];

export const HEADER_RIGHT_MENU_INFO_SIGN_OUT: HeaderRightMenuInfo = [
  {
    text: "Sign in",
    path: EFO_ROUTE_PATHS.signIn,
    style: "text",
    icon: <IconLogIn width={20} height={20} color="#515C6C" />,
  },
  {
    text: "Sign up",
    path: EFO_ROUTE_PATHS.signUp,
    style: "line",
  },
];

export const HEADER_RIGHT_MENU_INFO_SIGN_IN: HeaderRightMenuInfo = [
  {
    text: "Sign out",
    path: EFO_ROUTE_PATHS.articleMain,
    style: "text",
    icon: <IconLogOut width={20} height={20} color="#515C6C" />,
  },
  {
    text: "My Account",
    path: EFO_ROUTE_PATHS.myAccount,
    style: "line",
  },
];
